/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".segmented-control.loading[_ngcontent-%COMP%]{opacity:.7;pointer-events:none}.segmented-control[_ngcontent-%COMP%]   li.disable[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{cursor:not-allowed;opacity:.5}\n/*# sourceMappingURL=segmented-control-radio.indra.component.css.map*/"];
export { styles as styles };
